// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aU4R3","title":"styles_title__3oX0d"};